import React, { useEffect, useState } from "react";
import { Bell, X } from "lucide-react";
import api from "@/lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";

export default function NotificationBell() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      setItems(data);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.debug("notifications load failed:", err?.message);
    }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  const dismiss = async (id) => {
    setItems((prev) => prev.filter((n) => n.id !== id));
    try { await api.delete(`/notifications/${id}`); } catch (err) {
      // eslint-disable-next-line no-console
      console.debug("notification dismiss failed:", err?.message);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notification-bell">
          <Bell className="h-4 w-4" strokeWidth={1.75} />
          {items.length > 0 && (
            <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-semibold grid place-items-center num" data-testid="notification-count">
              {items.length}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-popover">
        <div className="px-4 py-3 border-b border-border">
          <div className="font-heading font-semibold">Notifications</div>
          <div className="text-xs text-muted-foreground mt-0.5">Auto-delete after 24 hours</div>
        </div>
        <div className="max-h-80 overflow-y-auto">
          {items.length === 0 && (
            <div className="px-4 py-8 text-center text-sm text-muted-foreground" data-testid="no-notifications">
              No notifications right now
            </div>
          )}
          {items.map((n) => (
            <div key={n.id} className="px-4 py-3 border-b border-border last:border-0 flex items-start gap-3 hover:bg-accent transition-colors" data-testid="notification-item">
              <div className="flex-1 text-sm">
                <div>{n.message}</div>
                <div className="text-[11px] text-muted-foreground mt-1 num">
                  {new Date(n.created_at).toLocaleString()}
                </div>
              </div>
              <button
                onClick={() => dismiss(n.id)}
                className="opacity-60 hover:opacity-100 transition-opacity"
                aria-label="Dismiss"
                data-testid="notification-dismiss"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
